import router from '../router/index'
import store from "../store/store";

import { axios, BaseApiUrl ,BaseUrl} from './axios_config';


export function GetBookingDeliveryList(params) {
    return axios.post(`${BaseApiUrl}/BookingDelivery/GetBookingDeliveryList`, params);
}

export function GetBookingDeliveryReport(params) {
    return axios.post(`${BaseApiUrl}/BookingDelivery/GetBookingDeliveryReport`, params);
}

//导出预约看板
export const exportBookingDeliveryReport = `${BaseApiUrl}/BookingDelivery/BookingDeliveryReportOut`;
 

export function ApprovalBookingDelivery(params) {
    return axios.post(`${BaseApiUrl}/BookingDelivery/ApprovalBookingDelivery`, params);
 }
 
export function RejectionBookingDelivery(params) {
    return axios.post(`${BaseApiUrl}/BookingDelivery/RejectionBookingDelivery`, params);
 }

export function GetBookingPro(params) {
    return axios.get(`${BaseApiUrl}/BookingDelivery/GetBookingPro`, { params });
}

export function GetBookingHolidayList(params) {
    return axios.post(`${BaseApiUrl}/BookingDelivery/GetBookingHolidayList`, params);
}

export const AddBookingHoliday = params => {
    return axios.post(`${BaseApiUrl}/BookingDelivery/AddBookingHoliday`, params);
};

//启用/禁用
export const bookingHolidayOperate = params => {
    return axios.get(`${BaseApiUrl}/BookingDelivery/BookingHolidayOperate`, { params: params });
};